import { render, staticRenderFns } from "./WeekView.vue?vue&type=template&id=37f4dc6a&scoped=true"
import script from "./WeekView.vue?vue&type=script&lang=js"
export * from "./WeekView.vue?vue&type=script&lang=js"
import style0 from "./WeekView.vue?vue&type=style&index=0&id=37f4dc6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f4dc6a",
  null
  
)

export default component.exports